import React from 'react';
import '../styles/Footer.css';

const SERVICES = [
  'Overseas Job Placement',
  'HR Recruitment Solutions',
  'Visa & Immigration',
  'Career Counseling',
  'Pre-Departure Support',
];

const INDUSTRIES = [
  'Healthcare',
  'Engineering & Construction',
  'Hospitality & Tourism',
  'Manufacturing & Logistics',
  'Information Technology',
];

const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__gold-line" />
      <div className="footer__grid">

        {/* Brand */}
        <div>
          <div className="footer__brand-logo">
            <div className="footer__brand-logo-main">Pragya HR</div>
            <div className="footer__brand-logo-sub">Solutions · Est. 2024</div>
          </div>
          <p className="footer__brand-desc">
            Empowering global careers and connecting talent worldwide. Trusted by
            professionals and organizations across continents.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <div className="footer__col-title">Navigation</div>
          <ul className="footer__links">
            {['home', 'about', 'services', 'contact'].map(page => (
              <li key={page} onClick={() => onNavigate(page)}>
                {page.charAt(0).toUpperCase() + page.slice(1)}{page === 'about' ? ' Us' : ''}
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <div className="footer__col-title">Services</div>
          <ul className="footer__links">
            {SERVICES.map(s => (
              <li key={s} onClick={() => onNavigate('services')}>{s}</li>
            ))}
          </ul>
        </div>

        {/* Industries */}
        <div>
          <div className="footer__col-title">Industries</div>
          <ul className="footer__links">
            {INDUSTRIES.map(ind => <li key={ind}>{ind}</li>)}
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__copy">© {year} Pragya HR Solutions. All Rights Reserved.</div>
        <div className="footer__copy footer__copy--gold">Empowering Global Careers · Connecting Talent Worldwide</div>
      </div>

      {/* Developed By Section */}
      <div className="footer__developed">
        <span className="footer__developed-text">Developed by</span>
        <a
          href="https://mpeoples.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__developed-link"
        >
          MPeoples Business Solutions Pvt Ltd
        </a>
      </div>
    </footer>
  );
};

export default Footer;